import { css } from '@emotion/css';

export const getDraggableValueContainerStyles = (width, ignoreWidth) => {
  return {
    container: css`
      display: flex;
      flex: 1;

      .Select__value-container {
        width: ${ignoreWidth ? 'unset' : `${width}px`};
        min-width: 200px;
      }
    `,
  };
};
